"use client";
import React from "react";
import {
    CARD_CONTAINER_WITH_BACKGROUND_CLASS,
    CARD_INNER_CONTAINER_CLASS,
    INNER_CARD_CONTAINER_WITH_BACKGROUND_CLASS,
    VIEW_PROFILE_TEXT,
} from "./constants";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { sendGTMEvent } from "@next/third-parties/google";
import { GoogleTagManagerEvents } from "../../../common";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";
import Link from "next/link";

const NewStylistCard = ({ description, image, index, name, link }) => {
    return (
        <div
            key={index}
            className={CARD_CONTAINER_WITH_BACKGROUND_CLASS}
            style={{
                backgroundImage: `url(${image?.url})`,
            }}
            loading="lazy"
        >
            <div className={INNER_CARD_CONTAINER_WITH_BACKGROUND_CLASS}>
                <div className={CARD_INNER_CONTAINER_CLASS}>
                    <TypographyMontserrat
                        align={"left"}
                        fontWeight={"medium"}
                        color={"White"}
                        text={name}
                        customStyle={" !text-xl lg:!text-[28px] "}
                    />
                    <TypographyMontserrat
                        align={"left"}
                        fontWeight={"medium"}
                        color={"White"}
                        text={description}
                        customStyle={"lg:mt-1 !text-[13px] sm:!text-base"}
                    />
                    <Link
                        href={link}
                        onClick={() => {
                            sendGTMEvent({
                                event: GoogleTagManagerEvents.navigationInteractions,
                                place: "Stylist Section",
                                menu_name: "stylist-section",
                            });
                        }}
                    >
                        <TypographyPoppins
                            text={VIEW_PROFILE_TEXT}
                            customStyle="mt-1 lg:mt-2 justify-self-start underline !font-medium !text-sm !text-white "
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NewStylistCard;
